import React from 'react';
import { func, bool } from 'prop-types';
import Button from '@alltrails/shared/denali/components/Button';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import * as styles from './styles/styles.module.scss';
import FormButton from '../../forms/FormButton';

const FormButtons = ({ onCancel, disabled }) => {
  return (
    <div className={styles.formButtonsContainer}>
      <Button text={StringConstantsMixin.strings.CANCEL} onClick={onCancel} testId="map-creator-cancel" variant="flat" />
      <FormButton disabled={disabled} value={StringConstantsMixin.strings.SAVE} width="auto" />
    </div>
  );
};

export default FormButtons;

FormButtons.propTypes = {
  onCancel: func.isRequired,
  disabled: bool
};

FormButtons.defaultProps = {
  disabled: false
};
